var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"youtube-video",attrs:{"src":'https://www.youtube-nocookie.com/embed/' + _vm.videoId + '?rel=0&modestbranding=1' + _vm.extraParams,"frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }